import React from 'react';
const benefits = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  desc: "Smetti di creare allenamenti, esercizi, progressioni tecniche, programmazioni stagionali e materiali didattici da zero. Apri il sistema, scegli l'allenamento più adatto e scendi in palestra con tutto già pronto."
}, {
  emoji: '👑',
  title: 'Allena con Maggiore Sicurezza',
  desc: 'Organizza ogni allenamento con una struttura professionale, insegna le abilità attraverso progressioni efficaci, accompagna lo sviluppo dei tuoi ginnasti e gestisci ogni lezione con un sistema completo pensato per gli allenatori di ginnastica artistica.'
}, {
  emoji: '🤸',
  title: 'Aiuta i Tuoi Ginnasti a Migliorare Più Velocemente',
  desc: 'Sviluppa basi tecniche solide, insegna le abilità in modo più efficace, aumenta la fiducia degli atleti e accompagnali con progressioni strutturate che favoriscono una crescita costante.'
}, {
  emoji: '😊',
  title: 'Offri Allenamenti Ancora Più Professionali',
  desc: "Mantieni ogni lezione organizzata grazie ad allenamenti pronti all'uso, strumenti pratici e sistemi di pianificazione professionali che migliorano l'esperienza sia dei ginnasti che delle loro famiglie."
}];
export function BenefitsSection() {
  return <section className="py-8 px-4 sm:px-6 bg-white border-t-4 border-brand-ivory" data-id="element-16">
      <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-center text-brand-navy mb-6 uppercase leading-tight" data-id="element-17">
        Cosa Cambierà da Oggi
      </h2>

      <div className="flex flex-col gap-3" data-id="element-18">
        {benefits.map((item, i) => <div key={i} className="bg-brand-ivory border-l-4 border-brand-gold p-4 rounded-r-lg shadow-sm flex gap-4 items-start" data-id="element-19">
            <div className="text-2xl shrink-0 leading-none mt-0.5" data-id="element-20">
              {item.emoji}
            </div>
            <div data-id="element-21">
              <h3 className="text-base font-heading font-bold text-brand-navy mb-1 uppercase tracking-tight leading-tight" data-id="element-22">
                {item.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-23">
                {item.desc}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}